module.exports = __webpack_public_path__ + "img/credits.0c8cca94.svg";